module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-combined.8234ad02.png";